import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";
import { EditOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Modal } from "antd";
import { api } from "../../lib/api.js";
import { HelpBubble } from "../help/helpBubble.jsx";
import { message } from "antd";

export const InstructorRefresher = ({ pilot, recency, setRecency }) => {
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      fis_date_refresher_course: recency.fis_date_refresher_course
        ? dayjs(recency.fis_date_refresher_course)
        : null,
      fis_date_refresher_course_newest: recency.fis_date_refresher_course_newest
        ? dayjs(recency.fis_date_refresher_course_newest)
        : null,
      fis_date_training_flight: recency.fis_date_training_flight
        ? dayjs(recency.fis_date_training_flight)
        : null,
      fis_date_exam: recency.fis_date_exam
        ? dayjs(recency.fis_date_exam)
        : null,
      bis_date_exam: recency.bis_date_exam
        ? dayjs(recency.bis_date_exam)
        : null,
      bis_ati: recency.bis_ati ? dayjs(recency.bis_ati) : null,
      fes_refresher: recency.fes_refresher
        ? dayjs(recency.fes_refresher)
        : null,
    });
  }, [recency, form]);

  const triggerSave = async () => {
    setLoading(true);
    const values = await form.validateFields();

    // make sure that course is the oldest date
    let fis_date_refresher_course = values.fis_date_refresher_course;
    let fis_date_refresher_course_newest =
      values.fis_date_refresher_course_newest;
    if (fis_date_refresher_course && fis_date_refresher_course_newest) {
      if (
        fis_date_refresher_course_newest.isBefore(fis_date_refresher_course)
      ) {
        fis_date_refresher_course = values.fis_date_refresher_course_newest;
        fis_date_refresher_course_newest = values.fis_date_refresher_course;
      }
    }
    fis_date_refresher_course = fis_date_refresher_course?.format("YYYY-MM-DD");
    fis_date_refresher_course_newest =
      fis_date_refresher_course_newest?.format("YYYY-MM-DD");

    const res = await api.post("gegevens/fis_dates.json", {
      user_id: pilot.id,
      bis_ati: values.bis_ati ? values.bis_ati.format("YYYY-MM-DD") : null,
      bis_date_exam: values.bis_date_exam
        ? values.bis_date_exam.format("YYYY-MM-DD")
        : null,
      fis_date_refresher_course: fis_date_refresher_course || null,
      fis_date_refresher_course_newest:
        fis_date_refresher_course_newest || null,
      fis_date_training_flight: values.fis_date_training_flight
        ? values.fis_date_training_flight.format("YYYY-MM-DD")
        : null,
      fis_date_exam: values.fis_date_exam
        ? values.fis_date_exam.format("YYYY-MM-DD")
        : null,
      fes_refresher: values.fes_refresher
        ? values.fes_refresher.format("YYYY-MM-DD")
        : null,
    });

    if (res) {
      setRecency(res?.currency?.recency);
      setShowModal(false);
    }
    setLoading(false);
  };

  return (
    <>
      <Button
        size="small"
        type="link"
        icon={<EditOutlined />}
        onClick={() => {
          if (pilot.home_club) return message.info($t('De refresher data worden beheerd de thuisclub van de vlieger.'));
          setShowModal(true);
        }}
      >
        {$t("Wijzig datum refresher, Instr. flt en examen")}
      </Button>

      <Modal
        title={$t("Wijzig datum refresher course en Instr. flt")}
        open={showModal}
        okText={$t("Opslaan")}
        cancelText={$t("Annuleren")}
        confirmLoading={loading}
        onCancel={() => setShowModal(false)}
        onOk={triggerSave}
      >
        <Form form={form} layout="vertical">
          {recency.is_instructor && (
            <>
              <Form.Item
                name="fis_date_refresher_course"
                label={$t("Instructor Refresher Training")}
              >
                <DatePicker
                  format={localStorage.localeFormat}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </Form.Item>

              <Form.Item
                name="fis_date_refresher_course_newest"
                label={
                  <>
                    {$t("Tweede")} {$t("Instructor Refresher Training")}{" "}
                    <HelpBubble
                      content={$t(
                        "Het is mogelijk om de Instructor Refresher Course in twee keer te doen, vul in dat geval de data van beide trainingen."
                      )}
                    />
                  </>
                }
              >
                <DatePicker
                  format={localStorage.localeFormat}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </Form.Item>

              <Form.Item
                name="fis_date_training_flight"
                label={$t("Instruction flight under supervision")}
              >
                <DatePicker
                  format={localStorage.localeFormat}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </Form.Item>

              <Form.Item
                name="fis_date_exam"
                label={
                  <>
                    {$t("Datum FI(s) examen of Assessment of Competence")}
                    <HelpBubble
                      content={
                        <div>
                          <p>
                            {$t(
                              "Examen is de datum waarop de restrictie eraf is gegaan"
                            )}. 
                            {$t(
                              "Je kan hier ook je 'Assessment of Competency' invullen, SFCL.360, om een niet-recente bevoegdheid weer actief te krijgen."
                            )}
                          </p>

                          <p>
                            {$t(
                              "In beide gevallen is de instructeur na deze periode 36 maanden uitgezonderd van de recency eisen voor het uitvoeren van instructievluchten."
                            )}
                          </p>
                        </div>
                      }
                    />
                  </>
                }
              >
                <DatePicker
                  format={localStorage.localeFormat}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </Form.Item>
            </>
          )}

          {recency.is_bis && (
            <>
              <Form.Item
                name="bis_date_exam"
                label={
                  <>
                    {$t("Datum BI(s) examen")}
                    <HelpBubble
                      content={$t(
                        "Datum waarop BI(s) examen (of Assessment of Competence) is behaald, kan ook de een AoC zoals beschreven in SFCL 365.b"
                      )}
                    />
                  </>
                }
              >
                <DatePicker
                  format={localStorage.localeFormat}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </Form.Item>

              <Form.Item
                name="bis_ati"
                label={
                  <>
                    {$t("Basic Instructor Ability to Instructor")}
                    <HelpBubble
                      content={$t(
                        "For UK SFCL, in case the instructor fails to meet the requirements ."
                      )}
                    />
                  </>
                }
              >
                <DatePicker
                  format={localStorage.localeFormat}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </Form.Item>
            </>
          )}

          {recency.is_fes && (
            <Form.Item
              name="fes_refresher"
              label={$t(
                'Recency voor examinatoren die elke 5 jaar een "FE(S) refresher course" moeten volgen.'
              )}
            >
              <DatePicker
                format={localStorage.localeFormat}
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
              />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </>
  );
};
